import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		position: "relative",
		"& > div:nth-last-child(1)": {
			borderBottom: "none",
		},
	},
});
const BodyRating = ({ classes, children }) => {
	return <div className={classes.root}>{children}</div>;
};

BodyRating.propTypes = {
	children: (props) => {
		let errorElement = false;
		props.children.forEach((child) => {
			if (child.type.displayName != "RowRating") {
				errorElement = true;
			}
		});
		if (errorElement) {
			return new Error("Element must be RowRating. Validation failed.");
		}
	},
};

export default withStyles(styles)(BodyRating);
